import {Checkbox, FormControlLabel} from "@mui/material";
import React from "react";

export const CheckboxForm = ({ checkboxes, formData, onChange}) => (
  <React.Fragment>
    {checkboxes.map(item => (
      <FormControlLabel
        key={item.key}
        control={<Checkbox />}
        label={
          <div className="text-xl">
            {item.label}
          </div>
        }
        value={formData[item.key]}
        onChange={(e, checked) => {
          onChange({...formData, [item.key]: checked})
        }}
      />
    ))}
  </React.Fragment>
)